import type { ReactNode } from 'react'

import type { StudioModeKey } from '@/constants/studio-nav'
import { CatalogListPageShell } from '@/shared/components/catalog/CatalogListPageShell'
import { StudioModeTabs } from '@/features/studio/components/StudioModeTabs'

type StudioHubPageShellProps = {
  mode: StudioModeKey
  children: ReactNode
}

/** 创作中心三种模式列表页共用壳：模式 Tab + 列表内容 */
export function StudioHubPageShell({ mode, children }: StudioHubPageShellProps) {
  return (
    <CatalogListPageShell>
      <StudioModeTabs active={mode} />
      {children}
    </CatalogListPageShell>
  )
}
